import React from 'react';
import { IconProps } from '../types';
const MinecraftSweetBerries: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="2" width="1" height="1" fill="rgba(105, 31, 33, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(105, 31, 33, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(105, 31, 33, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(105, 31, 33, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(223, 70, 126, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(165, 7, 0, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(165, 7, 0, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(105, 31, 33, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(105, 31, 33, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(165, 7, 0, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(165, 7, 0, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(130, 11, 5, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(105, 31, 33, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(105, 31, 33, 255)" />
<rect x="2" y="5" width="1" height="1" fill="rgba(41, 82, 48, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(40, 98, 64, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(105, 31, 33, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(130, 11, 5, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(130, 11, 5, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(130, 11, 5, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(105, 31, 33, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(223, 70, 126, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(165, 7, 0, 255)" />
<rect x="14" y="5" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(40, 98, 64, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(40, 98, 64, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(41, 82, 48, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(56, 14, 15, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(105, 31, 33, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(165, 7, 0, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(130, 11, 5, 255)" />
<rect x="14" y="6" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(40, 98, 64, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(41, 82, 48, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(29, 56, 34, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(56, 14, 15, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(56, 14, 15, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(56, 14, 15, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(29, 56, 34, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(41, 82, 48, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(41, 82, 48, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(29, 56, 34, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(29, 56, 34, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(56, 14, 15, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(56, 14, 15, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(56, 14, 15, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(41, 82, 48, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(41, 82, 48, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(40, 98, 64, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(41, 82, 48, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(56, 14, 15, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(56, 14, 15, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(105, 31, 33, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(105, 31, 33, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(40, 98, 64, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(40, 98, 64, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(41, 82, 48, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(29, 56, 34, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(56, 14, 15, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(105, 31, 33, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(223, 70, 126, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(165, 7, 0, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(165, 7, 0, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(29, 56, 34, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(29, 56, 34, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(29, 56, 34, 255)" />
<rect x="1" y="11" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(56, 14, 15, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(105, 31, 33, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(165, 7, 0, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(165, 7, 0, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(130, 11, 5, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="1" y="12" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(165, 7, 0, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(130, 11, 5, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(130, 11, 5, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(69, 20, 21, 255)" />
</svg>);
export default MinecraftSweetBerries;